import validate from 'validate.js';
import schema from './error/errorsSchema';
import { prettifyPolicy } from './prettifyPolicy';
import { MainFormState } from '../../types/forms/form.def';
import { Enum_Commande_Methodepaiement } from '../../graphql/generated/graphql';
import { getErrors } from './error/getErrors';
import { isValid } from './error/isValid';

export const errorAndStateParams = (
  field: string,
  value: unknown,
  state: MainFormState<any>
): any => {
  value = prettifyPolicy[field]
    ? prettifyPolicy[field](value, state.values[field])
    : value;

  let errors = state.errors;
  const noTouchErrors = state.errors;

  let message = validate({ [field]: value }, schema);
  errors = getErrors(
    errors,
    field,
    message && message[field] && message[field][0]
  );

  if (field === 'confirm') {
    message = validate(
      { password: state.values.password, [field]: value },
      schema
    );
    errors = getErrors(
      errors,
      field,
      message && message[field] && message[field][0]
    );
  }
  if (!state.values.affilie) {
    if (
      field === 'tel' &&
      state.values.methodepaiement === Enum_Commande_Methodepaiement.Cb
    ) {
      message = validate({ mobile: value }, schema);
      errors = getErrors(
        errors,
        'tel',
        message && message['mobile'] && message['mobile'][0]
      );
    }
    if (field === 'methodepaiement') {
      const checkTel =
        value === Enum_Commande_Methodepaiement.Cb ? 'mobile' : 'tel';
      const msg1 = validate({ [checkTel]: state.values.tel }, schema);
      const msg2 = validate({ [field]: value }, schema);
      errors = {
        ...errors,
        tel: (msg1 && msg1[checkTel] && msg1[checkTel][0]) || false,
        methodepaiement: (msg2 && msg2[field] && msg2[field][0]) || false
      };
    }
  }

  const checkValid = () => {
    if (
      state.values.methodepaiement !== undefined ||
      errors.methodepaiement !== undefined
    ) {
      return isValid(errors);
    } else {
      return false;
    }
  };

  if (field !== 'sameDeliveryInformation') {
    return {
      ...state,
      values: {
        ...state.values,
        [field]: value
      },
      errors,
      isValid: checkValid()
    };
  } else {
    return {
      ...state,
      errors: noTouchErrors,
      isValid: checkValid()
    };
  }
};
